import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/_environments/environment';
import { lastValueFrom, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Case } from '@app/_models/case';
import { Cat } from '@app/_models/cat';
import { ClaimNote } from '../_models/noteDetails';
import { AccountService, AlertService } from '.';
import { ReceivedSummary } from '@app/_models/received-summary';
import { DatePipe } from '@angular/common';
import { Peril } from '@app/_models/peril';
import { Note } from '@app/_models/note';
import { Router } from '@angular/router';
import { VClaimsAll } from '@app/_models/vClaimsAll';
import { VClaim } from '@app/_models/vClaim';
import { pagedVClaim } from '@app/_models/paged-vclaim';

@Injectable({
  providedIn: 'root',
})
export class RestService {
  errorMsg: string = '';
  //private cache$!: Observable<Case[]>;
  //Inject the HttpClient module to the constructor params
  constructor(
    private http: HttpClient,
    private accountService: AccountService,
    private alertService: AlertService,
    private datePipe: DatePipe,
    private router: Router
  ) {}

  // getData() {
  //   if (!this.cache$) {
  //     this.cache$ = this.anyHttpCall().pipe(
  //       shareReplay(1)
  //     );
  //   }
  //   return this.cache$;
  // }

  // anyHttpCall(): Observable<Case[]> {
  //   return this.http.get<Object[]>(`${environment.casesLatestApiUrl}` + this.accountService.subscriptionKey).pipe(
  //     // use the map() operator to return the data property of the response object
  //     // the operator enables to map the response of the Observable stream to the data value
  //     map(data => data.map(obj => this.toCase(obj))),
  //     catchError((err) => {
  //       this.alertService.clear();
  //       this.alertService.error(err);
  //       //Handle the errors
  //       return throwError(err);//Rethrow it back to component
  //     })
  //   );
  // }

  //GET the list of latest cases from the REST API using HttpClient
  getLatestCases(): Observable<Case[]> {
    return this.http
      .get<Object[]>(
        `${environment.claimsLatestApiUrl}` +
          this.accountService.isAllianzSubscriptionKey
      )
      .pipe(
        // use the map() operator to return the data property of the response object
        // the operator enables to map the response of the Observable stream to the data value
        map((data) => data.map((obj) => this.toCase(obj))),
        catchError((err) => {
          this.alertService.clear();
          this.alertService.error(err);
          //Handle the errors
          return throwError(err); //Rethrow it back to component
        })
      );
  }

  async getLatestCasesAsync() {
    const promise = new Promise<Case[]>((resolve, reject) => {
      this.http
        .get<Object[]>(
          `${environment.claimsLatestApiUrl}` +
            this.accountService.isAllianzSubscriptionKey
        )
        .subscribe({
          next: (res: any) => {
            return resolve(res.map((res: any) => this.toCase(res)));
          },
          error: (error: any) => {
            reject(error);
          },
          complete: () => {},
        });
    });
    return promise;
  }

  //GET the list of latest cases from the REST API using HttpClient
  getVClaim(consultant: string, adminUser: boolean): Observable<VClaim[]> {
    var url =
      `${environment.wgilAPIBaseUrl}` +
      'vWGICases/Claims' +
      this.accountService.subscriptionKey +
      '&Status=Open';
    /*if (!adminUser){
        url = url + '&consultant=' + consultant;
      }*/
    var claims = this.http.get<Object[]>(url).pipe(
      map((data) => data.map((obj) => this.toVClaim(obj))),
      catchError((err) => {
        this.alertService.clear();
        this.alertService.error(err);
        //Handle the errors
        return throwError(err); //Rethrow it back to component
      })
    );
    return claims;
  }

  getVClaimsAll(
    consultant: string,
    adminUser: boolean
  ): Observable<VClaimsAll[]> {
    var url =
      `${environment.wgilAPIBaseUrl}` +
      'vClaimsAll/Claims' +
      this.accountService.subscriptionKey +
      '&Status=Open';
    /*if (!adminUser){
        url = url + '&consultant=' + consultant;
      }*/
    var claims = this.http.get<Object[]>(url).pipe(
      map((data) => data.map((obj) => this.toVClaimsAll(obj))),
      catchError((err) => {
        this.alertService.clear();
        this.alertService.error(err);
        //Handle the errors
        return throwError(err); //Rethrow it back to component
      })
    );
    return claims;
  }

  async getPagedVClaims(
    pageNumber: number,
    pageSize: number,
    searchTerm: string = '',
    clientFriendlyName: string = '',
    isHMAUser: Boolean = false,
    isLatest: Boolean = true
  ) {
    const result = this.http
      .get<pagedVClaim>(
        `${environment.wgilAPIBaseUrl}` +
          'vClaimsAll/PagedClaimRecords' +
          this.accountService.subscriptionKey +
          '&pageNumber=' +
          `${pageNumber}` +
          '&pageSize=' +
          `${pageSize}` +
          '&searchTerm=' +
          `${searchTerm}` +
          '&isHMAUser=' +
          `${isHMAUser}` +
          `&clientFriendlyName=` +
          `${clientFriendlyName}` +
          '&isLatest=' +
          `${isLatest}`
      )
      .toPromise();
    return result;
    //return await this.http.get<pagedVClaim>(`${environment.wgilAPIBaseUrl}` + '/vClaimsAll/PagedClaimRecords' + this.accountService.subscriptionKey + '&clientFriendlyName=JvRcaTkbYXlirKZj1wgRaQ%3D%3D').toPromise();
  }

  // Get Paged List of Claims
  getvClaimsPaged(
    pageNumber: number,
    pageSize: number,
    searchTerm: string = '',
    clientFriendlyName: string = '',
    isHMAUser: Boolean = false,
    isLatest: Boolean = true
  ): Observable<VClaimsAll> {
    const result = this.http.get<VClaimsAll>(
      `${environment.wgilAPIBaseUrl}` +
        'vClaimsAll/PagedClaimRecords?pageNumber=' +
        `${pageNumber}` +
        '&pageSize=' +
        `${pageSize}` +
        '&searchTerm=' +
        `${searchTerm}` +
        '&isHMAUser=' +
        `${isHMAUser}` +
        `&clientFriendlyName=` +
        `${clientFriendlyName}` +
        '&isLatest=' +
        `${isLatest}` +
        '&subscription-key=79c1934d47f54b818f72e00b76118d6a'
    );
    return result;
  }

  /*getvClaimsPaged(
    pageNumber: number,
    pageSize: number,
    searchTerm: string = '',
    clientFriendlyName: string = '',
    isHMAUser: Boolean = false,
    isLatest: Boolean = true
  ): Observable<VClaimsAll[]> {
    const result = this.http.get<Object[]>(
      `${environment.wgilAPIBaseUrl}` +
        'vClaimsAll/PagedClaimRecords?pageNumber=' +
        `${pageNumber}` +
        '&pageSize=' +
        `${pageSize}` +
        '&searchTerm=' +
        `${searchTerm}` +
        '&isHMAUser=' +
        `${isHMAUser}` +
        `&clientFriendlyName=` +
        `${clientFriendlyName}` +
        '&isLatest=' +
        `${isLatest}` +
        '&subscription-key=79c1934d47f54b818f72e00b76118d6a'
    ).pipe(map(data => data.map((obj) => this.toVClaimsAll(obj))),
      catchError((err) => {
        this.alertService.clear();
        this.alertService.error(err);
        //Handle the errors
        return throwError(err); //Rethrow it back to component
      })
    );
    return result
  }*/

  //GET the list of latest cases from the REST API using HttpClient
  getAllOpenCases(): Observable<Case[]> {
    return this.http
      .get<Object[]>(
        `${environment.wgilAPIBaseUrl}` +
          'WgicasesOpens' +
          this.accountService.subscriptionKey
      )
      .pipe(
        // use the map() operator to return the data property of the response object
        // the operator enables to map the response of the Observable stream to the data value
        map((data) => data.map((obj) => this.toCase(obj))),
        catchError((err) => {
          this.alertService.clear();
          this.alertService.error(err);
          //Handle the errors
          return throwError(err); //Rethrow it back to component
        })
      );
  }

  //GET the list of latest cases from the REST API using HttpClient
  getCATClaims(): Observable<Case[]> {
    return this.http
      .get<Object[]>(
        `${environment.catReportApiUrl}` + this.accountService.subscriptionKey
      )
      .pipe(
        // use the map() operator to return the data property of the response object
        // the operator enables to map the response of the Observable stream to the data value
        map((data) => data.map((obj) => this.toCase(obj))),
        catchError((err) => {
          this.alertService.clear();
          this.alertService.error(err);
          //Handle the errors
          return throwError(err); //Rethrow it back to component
        })
      );
  }

  //GET the list of latest cases from the REST API using HttpClient
  getE2eEoLClaims(): Observable<Case[]> {
    return this.http
      .get<Object[]>(
        `${environment.e2eReportApiUrl}` + this.accountService.subscriptionKey
      )
      .pipe(
        // use the map() operator to return the data property of the response object
        // the operator enables to map the response of the Observable stream to the data value
        map((data) => data.map((obj) => this.toCase(obj))),
        catchError((err) => {
          this.alertService.clear();
          this.alertService.error(err);
          //Handle the errors
          return throwError(err); //Rethrow it back to component
        })
      );
  }

  //GET the list of latest cases from the REST API using HttpClient
  getCatsList(): Observable<Cat[]> {
    const params = new HttpParams().set('sort', 'catId').set('order', 'desc');

    return this.http
      .get<Object[]>(
        `${environment.catsListApiUrl}` + this.accountService.subscriptionKey,
        { params: params }
      )
      .pipe(
        // use the map() operator to return the data property of the response object
        // the operator enables to map the response of the Observable stream to the data value
        map((data) => data.map((obj) => this.toCAT(obj)).sort()),
        catchError((err) => {
          this.alertService.clear();
          this.alertService.error(err);
          //Handle the errors
          return throwError(err); //Rethrow it back to component
        })
      );
  }

  async isValidCaseID(refNo: number): Promise<boolean> {
    let retVal: boolean = false;
    const promise = this.http
      .get(
        `${environment.claimsLatestApiUrl}` +
          '/IsValidRefNo/' +
          refNo +
          this.accountService.isAllianzSubscriptionKey
      )
      .toPromise();
    promise
      .then((data) => {
        retVal = JSON.stringify(data) == 'true' ? true : false;
        if (retVal) this.router.navigate(['./case-details/' + refNo]);
        else {
          this.router.navigate(['.']);
          this.alertService.error(
            'Invalid RefNo ' +
              refNo +
              '. This claim either could be archived or not yet registered. Please contact Mk3 IT-Helpdesk'
          );
        }
      })
      .catch(() => {
        retVal = false;
        this.router.navigate(['.']);
        this.alertService.error(
          'Unspecified error. Please contact Mk3 IT-Helpdesk'
        );
      });
    return retVal;
  }

  //GET claim details by ID (Mk3refNo)
  /*async getClaimByMk3Ref(id: number) {
    const promise = new Promise<void>((resolve, reject) => {
      this.http.get<Case>(`${environment.claimsLatestApiUrl}` + '/' + id + this.accountService.isAllianzSubscriptionKey, { headers: new HttpHeaders({ timeout: `${20000}` }) })
        .subscribe({
          next: (res: any) => {
            return resolve(res);
          },
          error: (error: any) => {
            reject(error);
          },
          complete: () => {
          },
        });
    });
    return promise;
  }*/

  //GET claim details by ID (Mk3refNo)
  async getClaimByMk3Ref(id: number) {
    var url =
      `${environment.wgilAPIBaseUrl}` +
      'vClaimsAll/PagedClaimRecords' +
      this.accountService.subscriptionKey +
      '&RefNo=' +
      id +
      //'&Status=Open&PageSize=1&clientFriendlyName=' + this.accountService.clientFriendlyName;
      '&PageSize=1&clientFriendlyName=' + this.accountService.clientFriendlyName;
    return this.http.get<pagedVClaim>(url).toPromise();
    /*.pipe(
      map((data) => data.map((obj) => this.toVClaimsAll(obj))),
      catchError((err) => {
        this.alertService.clear();
        this.alertService.error(err);
        //Handle the errors
        return throwError(err); //Rethrow it back to component
      })
    );*/
    //return claims;
  }

  /* async getClaimByClaimNumber(caseNo: string) {
    const data = await lastValueFrom(this.http.get<Case[]>(`${environment.claimsLatestApiUrl}` + '/GetByClaimNumber/' + caseNo + this.accountService.subscriptionKey, { headers: new HttpHeaders({ timeout: `${20000}` }) }))
      .then((data: Case[]) => {
        if (data[0].refNo)
          this.router.navigate(['./case-details/' + data[0].refNo]);
        else {
          this.router.navigate(['.']);
          this.alertService.error('Invalid Claim Number ' + caseNo + '. This claim either could be archived or not yet registered. Please contact Mk3 IT-Helpdesk');
        }
      })
      .catch(() => {
        this.router.navigate(['.']);
        this.alertService.error('Invalid Claim Number ' + caseNo + '. This claim either could be archived or not yet registered. Please contact Mk3 IT-Helpdesk');
      });
  }*/

  async getClaimByClaimNumber(caseNo: string) {
    var url =
      `${environment.wgilAPIBaseUrl}` +
      'vClaimsAll/PagedClaimRecords' +
      this.accountService.subscriptionKey +
      '&CaseNo=' +
      caseNo +
      //'&Status=Open&PageSize=1&clientFriendlyName=' + this.accountService.clientFriendlyName;
      '&PageSize=1&clientFriendlyName=' + this.accountService.clientFriendlyName;
    return this.http.get<pagedVClaim>(url).toPromise();
  }

  /*async getClaimByClaimNumber(caseNo: string) {
    const promise = this.http
      .get<Case[]>(
        `${environment.claimsAllApiUrl}` +
          '/GetByClaimNumber/' +
          caseNo +
          this.accountService.subscriptionKey,
        { headers: new HttpHeaders({ timeout: `${20000}` }) }
      )
      .toPromise();
    promise
      .then((data: Case[] | undefined) => {
        if (
          data![0].refNo &&
          (data![0].clientId == 1 || data![0].clientId == 3)
        )
          this.router.navigate(['./case-details/' + data![0].refNo]);
        else {
          this.router.navigate(['.']);
          this.alertService.error(
            'Invalid Claim Number ' +
              caseNo +
              '. This claim either could be archived or not yet registered. Please contact Mk3 IT-Helpdesk'
          );
        }
      })
      .catch(() => {
        this.router.navigate(['.']);
        this.alertService.error(
          'Invalid Claim Number ' +
            caseNo +
            '. This claim either could be archived or not yet registered. Please contact Mk3 IT-Helpdesk'
        );
      });
  }*/

  //GET claim details by ID (Mk3refNo)
  /*async getClaimByMk3Ref(id: number) {
    return this.http.get<Case>(`${environment.claimsLatestApiUrl}` + '/' + id + this.accountService.subscriptionKey).pipe(map(Case => Case)
    );
  }*/

  /*async getClaimByClaimNumber(caseNo: string) {
    //console.log('getClaimByClaimNumber:caseNo: ' + caseNo);
    //console.log('getClaimByClaimNumber:HTTP GET Request: ' + `${environment.claimsLatestApiUrl}` + '/GetByClaimNumber/' + caseNo + this.accountService.subscriptionKey);
    return this.http.get<Case[]>(`${environment.claimsLatestApiUrl}` + '/GetByClaimNumber/' + caseNo + this.accountService.subscriptionKey).pipe(map(Case => Case)
    );
  }*/

  //GET Claim Notes by ID (refNo)
  getClaimNotes(refNo: number): Observable<ClaimNote[]> {
    return this.http
      .get<Object[]>(
        `${environment.claimNotesListApiUrl}` +
          '/' +
          refNo +
          this.accountService.subscriptionKey+
          '&IsHmaOrContractor=' +
          false 
      )
      .pipe(
        //map(data => data.map(obj => this.toNoteDetails(obj))),
        map((data) =>
          data
            .map((obj) => this.toNoteDetails(obj))
            .filter((d) => d.private == 0)
        ),
        catchError((error) => {
          let errorMsg: string;
          if (error.error instanceof ErrorEvent) {
            this.errorMsg = `Error: ${error.error.message}`;
          } else {
            this.errorMsg = this.getServerErrorMessage(error);
          }
          this.alertService.clear();
          this.alertService.error(this.errorMsg);
          return throwError(this.errorMsg);
        })
      );
  }

  //GET Claim Received Summaries For the Date Range
  getClaimReceivedSummary(startDate: Date, endDate: Date): Observable<any> {
    return this.http
      .get<ReceivedSummary[]>(
        `${environment.wgilAPIBaseUrl}` +
          'ClaimReceivedSummeries' +
          this.accountService.subscriptionKey +
          '&fromDT=' +
          this.datePipe.transform(startDate, 'yyyy-MM-dd') +
          '&toDT=' +
          this.datePipe.transform(endDate, 'yyyy-MM-dd')
      )
      .pipe(
        //map(data => data.map(obj => this.toSummary(obj))),
        catchError((error) => {
          let errorMsg: string;
          if (error.error instanceof ErrorEvent) {
            this.errorMsg = `Error: ${error.error.message}`;
          } else {
            this.errorMsg = this.getServerErrorMessage(error);
          }
          this.alertService.clear();
          this.alertService.error(this.errorMsg);
          return throwError(this.errorMsg);
        })
      );
  }

  //GET Perils Summary For the Date Range
  getPerilsSummary(startDate?: Date, endDate?: Date): Observable<any> {
    return this.http
      .get<ReceivedSummary[]>(
        `${environment.wgilAPIBaseUrl}` +
          'PerilsSummaries' +
          this.accountService.subscriptionKey +
          '&fromDT=' +
          this.datePipe.transform(startDate, 'yyyy-MM-dd') +
          '&toDT=' +
          this.datePipe.transform(endDate, 'yyyy-MM-dd')
      )
      .pipe(
        map((data) => data.map((obj) => this.toPeril(obj))),
        catchError((error) => {
          let errorMsg: string;
          if (error.error instanceof ErrorEvent) {
            this.errorMsg = `Error: ${error.error.message}`;
          } else {
            this.errorMsg = this.getServerErrorMessage(error);
          }
          this.alertService.clear();
          this.alertService.error(this.errorMsg);
          return throwError(this.errorMsg);
        })
      );
  }

  addNewNote(note: Note) {
    return this.http
      .post(
        `${environment.wgilAPIBaseUrl}` +
          'WgilClaimNotes' +
          this.accountService.subscriptionKey,
        note
      )
      .pipe(
        catchError((error) => {
          let errorMsg: string;
          if (error.error instanceof ErrorEvent) {
            this.errorMsg = `Error: ${error.error.message}`;
          } else {
            this.errorMsg = this.getServerErrorMessage(error);
          }
          this.alertService.clear();
          this.alertService.error(this.errorMsg);
          return throwError(this.errorMsg);
        })
      );
  }

  getClaimFiles(filePath: string): Observable<any> {
    return this.http
      .get<string>(
        `${environment.mk3AzureApiUrl}` +
          '/Files/' +
          filePath +
          this.accountService.subscriptionKey
      )
      .pipe(catchError(this.handleError));
  }

  // downloadFile(folderName: string, fileName: string): Observable<any> {
  //   return this.http.get(`${environment.mk3AzureApiUrl}` + '/Download/' + folderName + '/' + fileName + this.accountService.subscriptionKey).pipe(
  //     catchError(this.handleError)
  //   );
  // }

  /*downloadFile(folderName: string, fileName: string): HttpResponse {
    let ret: any;
    this.http.get(`${environment.mk3AzureApiUrl}` + '/Download/' + folderName + '/' + fileName + this.accountService.subscriptionKey).subscribe((response: any) => {
      //this.sharedService.onSuccess('', '', () => {
        //this.util.downloadFile(response);
        ret = response;
      //}
      //);
    })
    return ret;
  }*/

  downloadTest() {
    return this.http.get(`${environment.mk3AzureApiUrl}` + '/Download/Export', {
      observe: 'response',
      responseType: 'blob',
    });
  }

  downloadFile(folderName: string, fileName: string) {
    //const promise = new Promise<Blob>((resolve, reject) => {
    //const headers = new HttpHeaders({ 'Content-Type': 'application/json', responseType : 'arraybuffer'});//arraybuffer
    //const headers = new HttpHeaders({ observe: 'response', responseType : 'blob'});//arraybuffer

    //headers.append("x-ms-date", Date.now.toString("R", CultureInfo.InvariantCulture));
    //headers.append("x-ms-date", moment(new Date()).toString());
    //headers.append("x-ms-version", "2021-08-06");

    //var authorization = 'Bearer '+ sessionStorage.getItem("access_token");

    //const headers = new HttpHeaders({ 'Content-Type': 'application/json', "Authorization": authorization, responseType : 'blob'});

    //this.http.get(`${environment.mk3AzureApiUrl}` + '/Download/' + folderName + '/' + fileName + this.accountService.subscriptionKey)
    return this.http.get(
      `${environment.mk3AzureApiUrl}` +
        '/Download/' +
        folderName +
        '/' +
        fileName +
        this.accountService.subscriptionKey,
      { observe: 'response', responseType: 'blob' }
    );

    // let headers = new HttpHeaders().set('Accept', 'application/octet-stream');
    // //this.http.get(`${environment.mk3AzureApiUrl}` + '/Download/' + folderName + '/' + fileName + this.accountService.subscriptionKey)
    // this.http.get(`${environment.mk3AzureApiUrl}` + '/Download/' + folderName + '/' + fileName + this.accountService.subscriptionKey,
    //  { headers, observe: 'body', reportProgress: true, responseType: 'arraybuffer' })
    /*       .subscribe({
          next: (res: Blob) => {
            console.log('res: ' + res.toString);
            return resolve(res);
          },
          error: (error: any) => {
            reject(error);
            console.log('downloadFile error: ', error);
          },
          complete: () => {
          },
        });
    });
    return promise;*/
  }

  //Convert the result to a Case object and return
  private toCase(obj: any): Case {
    return {
      refNo: obj.refNo,
      caseNo: obj.caseNo,
      lastNameS: obj.lastNameS,
      policyNo: obj.policyNo,
      recD: obj.recD,
      status: obj.status,
      consultant: obj.consultant,
      situationStreet: obj.situationStreet,
      situationSuburb: obj.situationSuburb,
      state: obj.state,
      postCode: obj.postCode,
      inspDate: obj.inspDate,
      firstContact: obj.firstContact,
      lastContact: obj.lastContact,
      comments: obj.comments,
      bldCompletion: obj.bldCompletion,
      ctsCompletion: obj.ctsCompletion,
      endToEnd: obj.endToEnd,
      buildingCover: obj.buildingCover,
      contentsCover: obj.contentsCover,
      llPolicy: obj.llPolicy,
      //llExtras: obj.llExtras,
      emergencyRepair: obj.emergencyRepair,
      largeLoss: obj.largeLoss,
      holdContact: obj.holdContact,
      reportStatus: obj.reportStatus,
      tempAccom: obj.tempAccom,
      bldEstimate: obj.bldEstimate,
      ctsEstimate: obj.ctsEstimate,
      acceptance: obj.acceptance,
      cat: obj.cat1,
      peril: obj.peril,
      dol: obj.dol,
      sentReport: obj.sentReport,
      xsDateRecD: obj.xsDateRecD,
      ecdEstimatedCompletionDate: obj.ecdEstimatedCompletionDate,
      mk3Fee: obj.mk3Fee,
      bldAmtSettled: obj.bldAmtSettled,
      ctsAmtSettled: obj.ctsAmtSettled,
      reInspDate: obj.reInspDate,
      officeContact: obj.officeContact,
      claimStatus: obj.claimStatus,
      statusModified: obj.statusModified,
      reOpened: obj.reOpened,
      lastInspDate: obj.lastInspDate,
      contactDays: obj.contactDays,
      totalEstimate: obj.totalEstimate,
      emergencyRepairModified: obj.emergencyRepairModified,
      dateFinalised: obj.dateFinalised,
      //contactPhone1Name: obj.contactPhone1Name,
      //contactphone1: obj.contactphone1,
      // contactPhone1Desc: obj.contactPhone1Desc,
      // contactPhone2Name: obj.contactPhone2Name,
      // contactphone2: obj.contactphone2,
      // contactPhone2Desc: obj.contactPhone2Desc,
      // contactPhone3Name: obj.contactPhone3Name,
      // contactphone3: obj.contactphone3,
      // contactPhone3Desc: obj.contactPhone3Desc,
      // contactEmail1Name: obj.contactEmail1Name,
      // emailAddress: obj.emailAddress,
      // emailAddress1Desc: obj.emailAddress1Desc,
      // contactEmail2Name: obj.contactEmail2Name,
      // emailAddress2: obj.emailAddress2,
      // emailAddress2Desc: obj.emailAddress2Desc,
      sowProvided: obj.sowProvided,
      sowReceived: obj.sowReceived,
      buildingWorksCompleted: obj.buildingWorksCompleted,
      contentsWorksCompleted: obj.contentsWorksCompleted,
      assessmentType: obj.assessmentType,
      claimFinalisedDate: obj.claimFinalisedDate,
      originalStatus: obj.originalStatus,
      informedInsdAssessmentOutcome: obj.informedInsdAssessmentOutcome,
      signedContractReceived: obj.signedContractReceived,
      formerCaseNo: obj.formerCaseNo,
      optionalExtrasType: obj.optionalExtrasType,
      clientId: obj.clientId,
    };
  }

  private toVClaim(obj: any): VClaim {
    return {
      refNo: obj.refNo,
      caseNo: obj.caseNo,
      recordedDate: obj.recordedDate,
      lastName: obj.lastName,
      situationStreet: obj.situationStreet,
      situationSuburb: obj.situationSuburb,
      state: obj.state,
      consultant: obj.consultant,
      consultantID: obj.consultantID,
      postCode: obj.postCode,
      dateOfLoss: obj.dateOfLoss,
      lastInspDate: obj.lastInspDate,
      lastAssessment: obj.lastAssessment,
      lastContact: obj.lastContact,
      contactDays: obj.contactDays,
      isHoldContact: obj.isHoldContact,
      acceptance: obj.acceptance,
      peril: obj.peril,
      estimatedCompletionDate: obj.estimatedCompletionDate,
      statusClaimTypeID: obj.statusClaimTypeID,
      statusClaimType: obj.statusClaimType,
      originalStatus: obj.originalStatus,
      reOpenedDate: obj.reOpenedDate,
      policyNo: obj.policyNo,
      oldCaseNo: obj.oldCaseNo,
      isVulnerableCustomer: obj.isVulnerableCustomer,
      iCACatastrophe: obj.iCACatastrophe,
      insurer: obj.insurer,
      optionalExtrasType: obj.optionalExtrasType,
      daysOpen: obj.daysOpen,
      wipLink: obj.wipLink,
    };
  }
  /*private toVClaimsAll(obj: any): VClaimsAll {
    return {
      refNo: obj.refNo,
      acceptance: obj.acceptance,
      assessmentType: obj.assessmentType,
      brandID: obj.brandID,
      brandName: obj.brandName,
      buildingCompletionDate: obj.buildingCompletionDate,
      buildingCover: obj.buildingCover,
      buildingEstimate: obj.buildingEstimate,
      caseNo: obj.caseNo,
      catastrophe: obj.catastrophe,
      clientFriendlyName: obj.clientFriendlyName,
      clientID: obj.clientID,
      comments: obj.comments,
      consultant: obj.consultant,
      consultantID: obj.consultantID,
      contactDays: obj.contactDays,
      contentsCompletionDate: obj.contentsCompletionDate,
      contentsCover: obj.contentsCover,
      contentsEstimate: obj.contentsEstimate,
      dateOfLoss: obj.dateOfLoss,
      dateScopeOfWorkProvided: obj.dateScopeOfWorkProvided,
      dateScopeOfWorkSignedReceived: obj.dateScopeOfWorkSignedReceived,
      daysOpen: obj.daysOpen,
      emergencyRepairModified: obj.emergencyRepairModified,
      emergencyRepairType: obj.emergencyRepairType,
      enDataClaimID: obj.enDataClaimID,
      endToEnd: obj.endToEnd,
      estimatedCompletionDate: obj.estimatedCompletionDate,
      excessBuilding: obj.excessBuilding,
      excessContents: obj.excessContents,
      excessDateReceived: obj.excessDateReceived,
      firstContactDate: obj.firstContactDate,
      formerCaseNo: obj.formerCaseNo,
      informedInsdAssessmentOutcome: obj.informedInsdAssessmentOutcome,
      inspectionDate: obj.inspectionDate,
      insuredFullName: obj.insuredFullName,
      isENDataClaim: obj.isENDataClaim,
      isHoldContact: obj.isHoldContact,
      isLargeLoss: obj.isLargeLoss,
      isQuoteRequest: obj.isQuoteRequest,
      isRestorationClaim: obj.isRestorationClaim,
      isVulnerableCustomer: obj.isVulnerableCustomer,
      landLordPolicy: obj.landLordPolicy,
      lastContactDate: obj.lastContactDate,
      lastInspDate: obj.lastInspDate,
      lastName: obj.lastName,
      officeContact: obj.officeContact,
      officeContactID: obj.officeContactID,
      optionalExtrasType: obj.optionalExtrasType,
      originalStatus: obj.originalStatus,
      peril: obj.peril,
      policyInception: obj.policyInception,
      policyInitialInception: obj.policyInitialInception,
      policyNumber: obj.policyNumber,
      postCode: obj.postCode,
      previousRefNo: obj.previousRefNo,
      receivedDate: obj.receivedDate,
      reInspectionDate: obj.reInspectionDate,
      reOpenedDate: obj.reOpenedDate,
      sentReportDate: obj.sentReportDate,
      signedContractReceived: obj.signedContractReceived,
      situationStreet: obj.situationStreet,
      situationSuburb: obj.situationSuburb,
      state: obj.state,
      statusClaimTypeID: obj.statusClaimTypeID,
      statusModified: obj.statusModified,
      temporaryAccommodation: obj.temporaryAccommodation,
      totalEstimate: obj.totalEstimate,
    };
  }*/

  private toVClaimsAll(obj: any): VClaimsAll {
    return {
      refNo: obj.refNo,
      acceptance: obj.acceptance,
      assessmentType: obj.assessmentType,
      brandID: obj.brandID,
      brandName: obj.brandName,
      buildingAmountSettled: obj.buildingAmountSettled,
      buildingCompletionDate: obj.buildingCompletionDate,
      buildingCover: obj.buildingCover,
      buildingEstimate: obj.buildingEstimate,
      buildingSumInsured: obj.buildingSumInsured,
      buildingWorksCompleted: obj.buildingWorksCompleted,
      caseNo: obj.caseNo,
      catastrophe: obj.catastrophe,
      clientFriendlyName: obj.clientFriendlyName,
      clientID: obj.clientID,
      comments: obj.comments,
      consultant: obj.consultant,
      consultantID: obj.consultantID,
      contactDays: obj.contactDays,
      contentsAmountSettled: obj.contentsAmountSettled,
      contentsCompletionDate: obj.contentsCompletionDate,
      contentsCover: obj.contentsCover,
      contentsEstimate: obj.contentsEstimate,
      contentsSumInsured: obj.contentsSumInsured,
      contentsWorksCompleted: obj.contentsWorksCompleted,
      dateOfLoss: obj.dateOfLoss,
      dateScopeOfWorkProvided: obj.dateScopeOfWorkProvided,
      dateScopeOfWorkSignedReceived: obj.dateScopeOfWorkSignedReceived,
      daysOpen: obj.daysOpen,
      denialEstimate: obj.denialEstimate,
      emergencyRepairEst: obj.emergencyRepairEst,
      emergencyRepairModified: obj.emergencyRepairModified,
      emergencyRepairType: obj.emergencyRepairType,
      enDataClaimID: obj.enDataClaimID,
      endToEnd: obj.endToEnd,
      estimatedCompletionDate: obj.estimatedCompletionDate,
      excessBuilding: obj.excessBuilding,
      excessContents: obj.excessContents,
      excessDateReceived: obj.excessDateReceived,
      firstContactDate: obj.firstContactDate,
      formerCaseNo: obj.formerCaseNo,
      informedInsdAssessmentOutcome: obj.informedInsdAssessmentOutcome,
      inspectionDate: obj.inspectionDate,
      insuredFullName: obj.insuredFullName,
      insurerApprovalReceivedDate: obj.insurerApprovalReceivedDate,
      isENDataClaim: obj.isENDataClaim,
      isHoldContact: obj.isHoldContact,
      isLargeLoss: obj.isLargeLoss,
      isQuoteRequest: obj.isQuoteRequest,
      isRestorationClaim: obj.isRestorationClaim,
      isVulnerableCustomer: obj.isVulnerableCustomer,
      landLordPolicy: obj.landLordPolicy,
      lastContactDate: obj.lastContactDate,
      lastInspDate: obj.lastInspDate,
      lastName: obj.lastName,
      lorAmountSettled: obj.lorAmountSettled,
      officeContact: obj.officeContact,
      officeContactID: obj.officeContactID,
      optionalExtrasType: obj.optionalExtrasType,
      originalStatus: obj.originalStatus,
      peril: obj.peril,
      policyInception: obj.policyInception,
      policyInitialInception: obj.policyInitialInception,
      policyNumber: obj.policyNumber,
      postCode: obj.postCode,
      previousRefNo: obj.previousRefNo,
      receivedDate: obj.receivedDate,
      reInspectionDate: obj.reInspectionDate,
      reOpenedDate: obj.reOpenedDate,
      reportStatus: obj.reportStatus,
      restorationEstimate: obj.restorationEstimate,
      restorationSettledAmount: obj.restorationSettledAmount,
      sentReportDate: obj.sentReportDate,
      signedContractReceived: obj.signedContractReceived,
      situationStreet: obj.situationStreet,
      situationSuburb: obj.situationSuburb,
      state: obj.state,
      statusClaimTypeID: obj.statusClaimTypeID,
      statusModified: obj.statusModified,
      temporaryAccommodation: obj.temporaryAccommodation,
      tempAccomCost: obj.tempAccomCost,
      totalEstimate: obj.totalEstimate,
      mk3Fee: obj.mk3Fee,
      insurerContactName: obj.insurerContactName,
      statusClaimType: obj.statusClaimType,
      claimRecommendationID: obj.claimRecommendationID,
      claimRecommendation: obj.claimRecommendation,
      buildingPriceRange: obj.buildingPriceRange
    }
  }

  /*private toCase(obj: any): Case {
    return {
      refNo: obj.refNo,
      caseNo: obj.caseNo,
      lastNameS: obj.lastNameS,
      policyNo: obj.policyNo,
      recD: obj.recD,
      status: obj.status,
      consultant: obj.consultant,
      situationStreet: obj.situationStreet,
      situationSuburb: obj.situationSuburb,
      state: obj.state,
      postCode: obj.postCode,
      inspDate: obj.inspDate,
      lastContact: obj.lastContact,
      comments: obj.comments,
      bldCompletion: obj.bldCompletion,
      ctsCompletion: obj.ctsCompletion,
      endToEnd: obj.endToEnd,
      buildingCover: obj.buildingCover,
      contentsCover: obj.contentsCover,
      llExtras: obj.llExtras,
      emergencyRepair: obj.emergencyRepair,
      largeLoss: obj.largeLoss,
      holdContact: obj.holdContact,
      reportStatus: obj.reportStatus,
      tempAccom: obj.tempAccom,
      bldEstimate: obj.bldEstimate,
      ctsEstimate: obj.ctsEstimate,
      acceptance: obj.acceptance,
      cat: obj.cat1,
      peril: obj.peril,
      dol: obj.dol,
      sentReport: obj.sentReport,
      xsDateRecD: obj.xsDateRecD,
      ecdEstimatedCompletionDate: obj.ecdEstimatedCompletionDate,
      mk3Fee: obj.mk3Fee,
      bldAmtSettled: obj.bldAmtSettled,
      ctsAmtSettled: obj.ctsAmtSettled,
      reInspDate: obj.reInspDate,
      officeContact: obj.officeContact,
      claimStatus: obj.claimStatus,
      statusModified: obj.statusModified,
      reOpened: obj.reOpened,
      lastInspDate: obj.lastInspDate,
      contactDays: obj.contactDays,
      totalEstimate: obj.totalEstimate,
      emergencyRepairModified: obj.emergencyRepairModified,
      dateFinalised: obj.dateFinalised,
      sowProvided: obj.sowProvided,
      sowReceived: obj.sowReceived,
      buildingWorksCompleted: obj.buildingWorksCompleted,
      contentsWorksCompleted: obj.contentsWorksCompleted,
      assessmentType: obj.assessmentType,
      claimFinalisedDate: obj.claimFinalisedDate,
      informedInsdAssessmentOutcome: obj.informedInsdAssessmentOutcome,
      signedContractReceived: obj.signedContractReceived,
      formerCaseNo: obj.formerCaseNo,
      optionalExtrasType: obj.optionalExtrasType
    };
  }*/

  //Convert the result to a Case object and return
  private toCAT(obj: any): Cat {
    return {
      catId: obj.catId,
      icaCat: obj.icaCat,
    };
  }

  //Convert the result to a Case object and return
  private toNoteDetails(obj: any): ClaimNote {
    return {
      refNo: obj.refNo,
      date: obj.date,
      addedBy: obj.addedBy,
      initiatedBy: obj.initiatedBy,
      notes: obj.notes,
      private: obj.private,
      timeStamp: obj.timeStamp,
      followUpDate: obj.followUpDate,
      typeDescription: obj.typeDescription,
      subTypeDescription: obj.subTypeDescription,
      reasonDescription: obj.reasonDescription,
    };
  }

  //Convert the result to a Peril object and return
  private toPeril(obj: any): Peril {
    return {
      perilID: obj.perilID,
      peril: obj.peril,
      count: obj.count,
    };
  }

  //Convert the result to a Summary object and return
  private toSummary(obj: ReceivedSummary): ReceivedSummary {
    return {
      receivedCount: obj.receivedCount,
      contact24: obj.contact24,
      contact48: obj.contact48,
      inspectedCount: obj.inspectedCount,
      finalisedReceivedInPeriodCount: obj.finalisedReceivedInPeriodCount,
      finalisedCountAll: obj.finalisedCountAll,
      acceptedFinalised: obj.acceptedFinalised,
      partialFinalised: obj.partialFinalised,
      denialRecommendedFinalised: obj.denialRecommendedFinalised,
      cancelledCount: obj.cancelledCount,
      cycleTime: obj.cycleTime,
      cashSettled: obj.cashSettled,
      completedByMk3Partners: obj.completedByMk3Partners,
      withdrawnFinalised: obj.withdrawnFinalised,
      otherFinalised: obj.otherFinalised,
      totalOpen: obj.totalOpen,
      totalYetToBeInspected: obj.totalYetToBeInspected,
      total30DaysOrLess: obj.total30DaysOrLess,
      total31To60DaysOld: obj.total31To60DaysOld,
      total61To90DaysOld: obj.total61To90DaysOld,
      totalOver90DaysOld: obj.totalOver90DaysOld,
      totalReOpened: obj.totalReOpened,
    };
  }

  //Error handler
  private handleError(error: HttpErrorResponse): any {
    if (error.error instanceof ErrorEvent) {
      //console.error('An error occurred:', error.error.message);
      this.alertService.error(error.error.message);
    } else {
      // console.error(
      //   `Backend returned code ${error.status}, ` +
      //   `body was: ${error.error}`);
      this.alertService.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    return throwError('Error occured; please try again later.');
  }

  private getServerErrorMessage(error: HttpErrorResponse): string {
    switch (error.status) {
      case 404: {
        return `Not Found: ${error.message}`;
      }
      case 403: {
        return `Access Denied: ${error.message}`;
      }
      case 500: {
        return `Internal Server Error: ${error.message}`;
      }
      default: {
        return `Unknown Server Error: ${error.message}`;
      }
    }
  }
  
  //GET case Contact by ID (refNo)
  getClaimContacts(id: number): Observable<any> {
    //}: Observable<Case[]>{
    return this.http
      .get(
        `${environment.claimContactApiUrl}` +
          '/' +
          id +
          this.accountService.subscriptionKey
      )
      .pipe(
        catchError((error) => {
          if (error.error instanceof ErrorEvent) {
            this.errorMsg = `Error: ${error.error.message}`;
          } else {
            this.errorMsg = this.getServerErrorMessage(error);
          }
          this.alertService.clear();
          this.alertService.error(this.errorMsg);
          return throwError(this.errorMsg);
        })
      );
  }
}
